import { ENHANCED_REVIEW_VERSION, allegationCapEnabled } from './adverseMediaArticlePolicy';
import { highestConcernArticleIndicators } from './adverseMediaSubjectIndicators';

// Optional organisation policies must use the same concern as the card/modal.
export function enhancedSummaryConcern(rows, assessments) {
  const adjusted = rows.some(row => {
    const assessment = assessments[String(row.id)]?.assessment;
    if (allegationCapEnabled(assessment?.concernPolicy)) return true;
    const review = assessment?.enhancedReview;
    return review?.version === ENHANCED_REVIEW_VERSION && review.status === 'completed' && review.adjustments?.length > 0;
  });
  if (!adjusted) return null;
  const indicators = highestConcernArticleIndicators(rows, assessments);
  if (indicators.concern === 'high') return { concernLabel: 'high concern', overallConcern: 85 };
  if (indicators.concern === 'medium') return { concernLabel: 'elevated concern', overallConcern: 55 };
  return null;
}
